import React, { useEffect, useState } from 'react';
import Button from './Button';
import { i18n } from '../App';
import uuidv4 from 'uuid/v4';

import { Container, Paper, Typography } from '@material-ui/core';

import { useCoolfoodContext } from './Store';
import { actions } from '../state/reducer';
import { formatGain, determineUnitAfterConversion } from '../calculationTools';

import { makeStyles } from '@material-ui/core/styles';

import postJson from '../coolfoodSync';

const useStyles = makeStyles(theme => ({
  buttons: {
    ...theme.buttons,
    marginTop: theme.spacing(3)
  },
  stepTitle: theme.stepTitle,
  commitList: {
    fontSize: 18,
    '& > div': {
      fontSize: 22
    }
  },
  gainsContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: theme.spacing(6),
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    fontSize: 18,
    textAlign: 'center'
  },
  gains: {
    color: theme.pink,
    fontSize: 20
  },
  buttonEngageContainer: {
    marginTop: theme.spacing(4),
    textAlign: 'center'
  },
  buttonEngage: {
    borderRadius: 0,
    boxShadow: 'none',
    backgroundColor: theme.pink,
    color: '#fff',
    paddingLeft: theme.spacing(8),
    paddingRight: theme.spacing(8),
    fontSize: 28,
    [theme.breakpoints.down('xs')]: {
      fontSize: 18
    },
    margin: '0 auto'
  },
  buttonNext: {
    borderRadius: 0,
    boxShadow: 'none',
    backgroundColor: theme.green,
    color: '#fff',
    paddingLeft: theme.spacing(8),
    paddingRight: theme.spacing(8),
    fontSize: 28,
    [theme.breakpoints.down('xs')]: {
      fontSize: 18
    },
    margin: '0 auto'
  }
}));

const ConfirmCommits = () => {
  const classes = useStyles();

  const [globalState, globalDispatch] = useCoolfoodContext();

  const [displayNextButton, showNextButton] = useState(false);

  const [totalGains, setTotalGains] = useState({
    eurFor1Month: 0,
    gbpFor1Month: 0,
    co2For1Month: 0,
    eurFor1Year: 0,
    gbpFor1Year: 0,
    co2For1Year: 0
  });

  const [formattedGains, setFormattedGains] = useState({
    moneyFor1Month: '',
    co2For1Month: '',
    moneyFor1year: '',
    co2For1Year: ''
  });

  useEffect(() => {
    globalDispatch({
      type: actions.SHOW_HELP,
      content: i18n._('Prêts à confirmer vos défis ? :)')
    });
  }, [globalDispatch]);

  useEffect(() => {
    if (globalState.commitsValidated)
      if (window._uuid) {
        globalDispatch({
          type: actions.SHOW_HELP,
          content: i18n._(
            'Merci pour votre nouvel engagement !<br>Et si vous proposiez à vos amis, votre famille de rejoindre la communauté Cool Food ? :)'
          )
        });
      } else {
        globalDispatch({
          type: actions.SHOW_HELP,
          content: i18n._(
            'Merci pour votre engagement !<br>Renseignez vos coordonnées afin d\'avoir accès à votre suivi personnalisé :)'
          )
        });
      }
  }, [globalDispatch, globalState.commitsValidated]);

  useEffect(() => {
    const computedTotalGains = totalGains;

    globalState.commits.forEach(commit => {
      computedTotalGains.co2For1Month += commit.gains.co2For1Month;
      computedTotalGains.co2For1Year += commit.gains.co2For1Year;
      computedTotalGains.eurFor1Month += commit.gains.eurFor1Month;
      computedTotalGains.eurFor1Year += commit.gains.eurFor1Year;
      computedTotalGains.gbpFor1Month += commit.gains.gbpFor1Month;
      computedTotalGains.gbpFor1Year += commit.gains.gbpFor1Year;
    });
    setTotalGains(computedTotalGains);
  }, [globalState.commits, totalGains]);

  useEffect(() => {
    const fGains = {
      co2For1Month: formatGain(
        totalGains.co2For1Month,
        globalState.language,
        {
          style: 'decimal',
          maximumFractionDigits: 0,
          minimumFractionDigits: 0
        },
        true
      ),
      co2For1Year: formatGain(
        totalGains.co2For1Year,
        globalState.language,
        {
          style: 'decimal',
          maximumFractionDigits: 0,
          minimumFractionDigits: 0
        },
        true
      )
    };

    let totalMoneyFor1Month = 0;
    let totalMoneyFor1Year = 0;
    let currency = '';

    if (globalState.language === 'fr') {
      totalMoneyFor1Month = totalGains.eurFor1Month;
      totalMoneyFor1Year = totalGains.eurFor1Year;
      currency = 'EUR';
    } else {
      totalMoneyFor1Month = totalGains.gbpFor1Month;
      totalMoneyFor1Year = totalGains.gbpFor1Year;
      currency = 'GBP';
    }

    fGains.moneyFor1Month = formatGain(
      Math.round(totalMoneyFor1Month),
      globalState.language,
      {
        style: 'currency',
        currency,
        maximumFractionDigits: 0,
        minimumFractionDigits: 0
      }
    );

    fGains.moneyFor1Year = formatGain(
      Math.round(totalMoneyFor1Year),
      globalState.language,
      {
        style: 'currency',
        currency,
        maximumFractionDigits: 0,
        minimumFractionDigits: 0
      }
    );

    setFormattedGains(fGains);
  }, [
    globalState.language,
    totalGains.co2For1Month,
    totalGains.co2For1Year,
    totalGains.eurFor1Month,
    totalGains.eurFor1Year,
    totalGains.gbpFor1Month,
    totalGains.gbpFor1Year
  ]);

  const validateCommits = () => {
    globalDispatch({ type: actions.COMMITS_VALIDATED, status: true });
    setTimeout(() => {
      showNextButton(true);
    }, 800);
    sendDatasToServer();
  };

  const sendDatasToServer = () => {
    const datas = {
      id_happening: globalState.happening.happening.id,
      commits: []
    };
    const now = new Date();
    const dateStart = new Date(now);
    dateStart.setDate(dateStart.getDate() + 1); // start next day, at least.
    while (dateStart.getDay() !== 1) dateStart.setDate(dateStart.getDate() + 1); // start on monday

    globalState.commits.forEach(commit => {
      const userCommit = {
        id_commitment: commit.id,
        user_uuid: globalState.coolfooder.uuid,
        commit_uuid: uuidv4(),
        value_now: commit.now ? commit.now.value : null,
        value_commitment: commit.commitment.value,
        number_of_beneficiaries: commit.numberOfBeneficiaries,
        gain_co2: commit.gains.co2For1Year,
        gain_eur: commit.gains.eurFor1Year,
        gain_gbp: commit.gains.gbpFor1Year,
        ts_taken: now.getTime(),
        date_taken: now.toISOString(),
        date_start: dateStart.toISOString(),
        datas: JSON.stringify({ commit, coolfooder: globalState.coolfooder })
      };
      datas.commits.push(userCommit);
    });

    postJson({
      action: 'ADD_COMMITS',
      data: datas,
      ts_disabled: null
    });
  };

  return (
    <Container fixed className="confirmCommits">
      <Typography className={`ribbon ${classes.stepTitle}`}>
        {i18n._('ETAPE 4 : C\'est le moment de s\'engager !')}
      </Typography>
      <div className={classes.commitList}>
        <div>{i18n._('Mes défis')}</div>
        <ul>
          {globalState.commits.map(commit => {
            const commitment = globalState.happening.commitments.find(
              c => c.id === commit.id
            );
            return <li key={commitment.id}>{commitment.name}</li>;
          })}
        </ul>
      </div>
      <Paper className={classes.gainsContainer}>
        <div>{i18n._('Vos gains sur 1 mois')}</div>
        <div className={classes.gains}>
          {formattedGains.co2For1Month}{' '}
          {determineUnitAfterConversion(totalGains.co2For1Month)} Co2 -{' '}
          {formattedGains.moneyFor1Month}
        </div>
        <div style={{ marginTop: '14px' }}>
          {i18n._('Et si vous prolongez vos défis sur 1 an')}
        </div>
        <div className={classes.gains}>
          {formattedGains.co2For1Year}{' '}
          {determineUnitAfterConversion(totalGains.co2For1Year)} Co2 -{' '}
          {formattedGains.moneyFor1Year}
        </div>
      </Paper>
      <div className={classes.buttonEngageContainer}>
        {!displayNextButton && (
          <Button
            className={`engageButton ${classes.buttonEngage}`}
            variant="contained"
            onClick={validateCommits}
          >
            {i18n._('Je m\'engage')}
          </Button>
        )}
        {displayNextButton && !window._uuid && (
          <Button
            className={`nextButton ${classes.buttonNext}`}
            variant="contained"
            onClick={() => globalDispatch({ type: actions.NEXT_SLIDE })}
          >
            {i18n._('Je renseigne mes coordonnées')}
          </Button>
        )}
        {displayNextButton && !!window._uuid && (
          <Button
            className={`nextButton ${classes.buttonNext}`}
            variant="contained"
            onClick={() => globalDispatch({ type: actions.NEXT_SLIDE })}
          >
            {i18n._('Une dernière petite chose')}
          </Button>
        )}
      </div>
      <div className={classes.buttons}>
        <Button
          color="primary"
          onClick={() => globalDispatch({ type: actions.PREV_SLIDE })}
          className="prevButton"
          disabled={globalState.commitsValidated}
        >
          {i18n._('Précédent')}
        </Button>
      </div>
    </Container>
  );
};

export default ConfirmCommits;
